import { useState } from "react";
import { useAuth } from "@clerk/react";
import { toast } from "sonner";
import { ConfirmDialog } from "@/components/ConfirmDialog";
import { makeApi } from "@/lib/api";

export const DeleteLoadDialog = ({ load, onClose, onDeleted, onRestored }) => {
  const { getToken } = useAuth();
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    const api = makeApi(getToken);
    setBusy(true);
    try {
      await api.delete(`/loads/${load.id}`);
      const id = load.id;
      onDeleted(id);
      onClose();
      toast.success(`Load ${load.carrier_number || load.load_number} moved to Trash`, {
        action: {
          label: "Undo",
          onClick: async () => {
            await api.post(`/trash/loads/${id}/restore`);
            toast.success("Load restored");
            onRestored?.();
          },
        },
      });
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not delete load");
    } finally {
      setBusy(false);
    }
  };

  const docs = load?.doc_count ?? load?.documents?.length ?? 0;
  return (
    <ConfirmDialog
      open={!!load}
      busy={busy}
      title={`Delete load #${load?.carrier_number || load?.load_number}?`}
      confirmLabel="Move to Trash"
      testId="delete-load-dialog"
      onCancel={onClose}
      onConfirm={confirm}
      description={
        <>
          <p>
            {docs > 0 ? (
              <>This also removes <strong>{docs === 1 ? "its 1 attached document" : `all ${docs} attached documents`}</strong> (ratecon, PODs/BOLs)</>
            ) : "This load has no documents attached"}
            {load?.invoice_id || load?.invoice ? " and its invoice" : ""}.
          </p>
          <p>Everything goes to Trash together. You can restore it within 30 days, after that it is deleted for good.</p>
        </>
      }
    />
  );
};
